export default "__VITE_ASSET__C53NrsGB__"